import {action, computed, observable} from "mobx";
import TodoItem from "./todo-item";
import { create, persist } from 'mobx-persist'
import { useSetFollowIds } from "../contexts/Articles/Articles";
import { Owner } from "../utils/util";
import moment from 'moment'
 
export type History = {urlPath:string,title:string,logo:string,time?: string,ownerName?:string}

export type ProjectItemProps = {name:string,id:string}
 
export class TodoList {
    @persist('list') @observable.shallow list: TodoItem[] = [];
    @persist @observable langIndex: number = 0;
     
}


export default new TodoList();